import React, { useState } from 'react';
import { Button, Icon, Select } from '@fourthwall/components';
import { RefreshIcon } from '@fourthwall/icons';
import * as S from './KlaviyoSetLists.styled';
export const KlaviyoSetLists = ({ setLists, isSettingLists, lists, refreshLists, isRefreshing, membersListId, newsletterListId, }) => {
    const CREATE_NEW_LIST_VALUE = 'create-new';
    const [selectedMembersListId, setSelectedMembersListId] = useState(membersListId || lists[0]?.listId || CREATE_NEW_LIST_VALUE);
    const [selectedNewsletterListId, setSelectedNewsletterListId] = useState(newsletterListId || lists[0]?.listId || CREATE_NEW_LIST_VALUE);
    const handleSetLists = async () => {
        try {
            await setLists({
                membersListId: selectedMembersListId === CREATE_NEW_LIST_VALUE ? undefined : selectedMembersListId,
                newsletterListId: selectedNewsletterListId === CREATE_NEW_LIST_VALUE ? undefined : selectedNewsletterListId,
            });
        }
        catch (error) {
            console.error('Failed to set Klaviyo lists:', error);
        }
    };
    const handleRefreshLists = async () => {
        try {
            await refreshLists();
        }
        catch (error) {
            console.error('Failed to refresh Klaviyo lists:', error);
        }
    };
    const selectOptions = [
        ...lists.map((list) => ({
            value: list.listId,
            label: list.listName,
        })),
        { value: CREATE_NEW_LIST_VALUE, label: '+ Create New List' },
    ];
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, "Configure your Lists"),
        React.createElement(S.Description, null, "Select which Klaviyo lists to sync your customer data to. Members list will receive your supporters. Newsletter list will receive customers who opt-in to marketing emails."),
        React.createElement(S.FormSection, null,
            React.createElement(S.SelectWithRefreshContainer, null,
                React.createElement(Select, { label: "Members List", value: selectedMembersListId, options: selectOptions, onValueChange: (value) => setSelectedMembersListId(value), fullWidth: true }),
                React.createElement(Button, { icon: React.createElement(Icon, { component: RefreshIcon, width: 16, height: 16 }), onClick: handleRefreshLists, loading: isRefreshing, disabled: isRefreshing }))),
        React.createElement(S.FormSection, null,
            React.createElement(S.SelectWithRefreshContainer, null,
                React.createElement(Select, { label: "Newsletter List", value: selectedNewsletterListId, options: selectOptions, onValueChange: (value) => setSelectedNewsletterListId(value), fullWidth: true }),
                React.createElement(S.Spacer, null))),
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: "Save Configuration", appearance: "primary", onClick: handleSetLists, loading: isSettingLists, disabled: isSettingLists }))));
};
